import type { Classified } from '@shopgnd/shared';
import { islandListingUrlParishSlug } from '@shopgnd/shared';

export type ClassifiedPathInput = Pick<Classified, 'id' | 'slug'> & {
  parish?: Classified['parish'] | null;
};

/**
 * Canonical classified URL after publish.
 * Carriacou & Petite Martinique: /grenada/{island-slug}/classifieds/{id-or-slug}
 * Mainland: /grenada/classifieds/{id-or-slug}
 * Post flow stays at /grenada/classifieds/post (parish chosen in the form).
 */
export function classifiedPath(c: ClassifiedPathInput): string {
  const segment = c.slug ?? c.id;
  const island = islandListingUrlParishSlug(c.parish);
  return island
    ? `/grenada/${island}/classifieds/${encodeURIComponent(segment)}`
    : `/grenada/classifieds/${encodeURIComponent(segment)}`;
}
